import React from "react";
class CampaignGroupList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items,
    };
  }
  // New Events
  handleNewBucket() {
    let items = [...this.state.items];
    items.push({ name: "", filter_string: "", filter_type: "contains", conditions: [] });
    this.setState({ items: items });
  }

  handleNewContainsCondition(oldItem) {
    let items = [...this.state.items];
    let item = items.find((x) => x == oldItem);
    item.conditions.push({ filter_type: "contains", filter_string: "", filter_condition: "or" });
    this.setState({ items: items });
  }

  handleNewNotContainsCondition(oldItem) {
    let items = [...this.state.items];
    let item = items.find((x) => x == oldItem);
    item.conditions.push({ filter_type: "notContains", filter_string: "", filter_condition: "and" });
    this.setState({ items: items });
  }

  // Change Events

  handleItemNameChange(event, oldItem) {
    let items = [...this.state.items];
    let item = items.find((x) => x == oldItem);
    item.name = event.target.value;
    this.setState({ items: items });
  }

  handleItemFilterTypeChange(event, oldItem) {
    let items = [...this.state.items];
    let item = items.find((x) => x == oldItem);
    item.filter_type = event.target.value;
    this.setState({ items: items });
  }

  handleItemInputChange(event, oldItem) {
    let items = [...this.state.items];
    let item = items.find((x) => x == oldItem);
    item.filter_string = event.target.value;
    this.setState({ items: items });
  }

  handleConditionInputChange(event, oldItem, conditionIndex) {
    let items = [...this.state.items];
    let item = items.find((x) => x == oldItem);
    let condition = item.conditions[conditionIndex];
    condition.filter_string = event.target.value;
    this.setState({ items: items });
  }

  handleConditionAndOrChange(event, oldItem, conditionIndex) {
    let items = [...this.state.items];
    let item = items.find((x) => x == oldItem);
    let condition = item.conditions[conditionIndex];
    condition.filter_condition = event.target.value;
    this.setState({ items: items });
  }

  // Remove Events

  removeItem(itemIndex) {
    let items = [...this.state.items];
    items.splice(itemIndex, 1);
    this.setState({ items: items });
  }

  removeCondition(oldItem, conditionIndex) {
    let items = [...this.state.items];
    let item = items.find((x) => x == oldItem);
    item.conditions.splice(conditionIndex, 1);
    this.setState({ items: items });
  }

  render() {
    const itemList = this.state.items.map((item, index) => {
      let containsList = item.conditions.map((condition, conditionIndex) => {
        if (condition.filter_type == "contains") {
          return (
            <React.Fragment key={conditionIndex}>
              <tr>
                <td>
                  <select
                    name={this.props.parentForm + "[campaign_bucket_" + index + "][contains][condition_" + conditionIndex + "[filter_condition]"}
                    value={condition.filter_condition}
                    onChange={(e) => this.handleConditionAndOrChange(e, item, conditionIndex)}>
                    <option value="or">OR</option>
                    <option value="and">AND</option>
                  </select>
                </td>
                <td></td>
              </tr>
              <tr className="spacer" style={{ height: "5px" }}></tr>
              <tr>
                <td>
                  <input
                    type="text"
                    name={this.props.parentForm + "[campaign_bucket_" + index + "][contains][condition_" + conditionIndex + "[filter_string]"}
                    value={condition.filter_string}
                    onChange={(e) => this.handleConditionInputChange(e, item, conditionIndex)}
                  />
                </td>
                <td>
                  <button name="button" type="button" onClick={() => this.removeCondition(item, conditionIndex)} style={{ background: "none" }}>
                    <i className="fas fa-minus-circle"></i>
                  </button>
                </td>
              </tr>
              <tr className="spacer" style={{ height: "10px" }}></tr>
            </React.Fragment>
          );
        }
      });

      let notContainsList = item.conditions.map((condition, conditionIndex) => {
        if (condition.filter_type == "notContains") {
          return (
            <React.Fragment key={conditionIndex}>
              <tr>
                <td>
                  <select
                    name={this.props.parentForm + "[campaign_bucket_" + index + "][not_contains][condition_" + conditionIndex + "[filter_condition]"}
                    value={condition.filter_condition}
                    onChange={(e) => this.handleConditionAndOrChange(e, item, conditionIndex)}>
                    <option value="or">OR</option>
                    <option value="and">AND</option>
                  </select>
                </td>
                <td></td>
              </tr>
              <tr className="spacer" style={{ height: "5px" }}></tr>
              <tr>
                <td>
                  <input
                    type="text"
                    name={this.props.parentForm + "[campaign_bucket_" + index + "][not_contains][condition_" + conditionIndex + "[filter_string]"}
                    value={condition.filter_string}
                    onChange={(e) => this.handleConditionInputChange(e, item, conditionIndex)}
                  />
                </td>
                <td>
                  <button name="button" type="button" onClick={() => this.removeCondition(item, conditionIndex)} style={{ background: "none" }}>
                    <i className="fas fa-minus-circle"></i>
                  </button>
                </td>
              </tr>
              <tr className="spacer" style={{ height: "10px" }}></tr>
            </React.Fragment>
          );
        }
      });

      return (
        <React.Fragment key={index}>
          <div className="mb-3">
            Name:&nbsp;
            <input
              type="text"
              name={this.props.parentForm + "[campaign_bucket_" + index + "][name]"}
              value={item.name}
              onChange={(e) => this.handleItemNameChange(e, item)}
            />
            <button name="button" type="button" onClick={() => this.removeItem(index)} style={{ background: "none" }}>
              <i className="fas fa-minus-circle"></i>
            </button>
          </div>
          <div className="mb-4">
            <table>
              <tbody>
                <tr>
                  <td>
                    <select
                      name={this.props.parentForm + "[campaign_bucket_" + index + "][filter_type]"}
                      value={item.filter_type}
                      onChange={(e) => this.handleItemFilterTypeChange(e, item)}
                      style={{ width: "auto" }}>
                      <option value="contains">Contains:</option>
                      <option value="notContains">Does Not Contain:</option>
                    </select>
                  </td>
                </tr>
                <tr className="spacer" style={{ height: "5px" }}></tr>
                <tr>
                  <td>
                    <input
                      type="text"
                      placeholder={this.props.propertyName}
                      name={this.props.parentForm + "[campaign_bucket_" + index + "][filter_string]"}
                      value={item.filter_string}
                      onChange={(e) => this.handleItemInputChange(e, item)}
                    />
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mb-4" style={{ width: "50%", float: "left" }}>
            <table>
              <tbody>
                <tr>
                  <td colSpan="2">Contains:</td>
                </tr>
                {containsList}
                <tr>
                  <td colSpan="2">
                    <span className="font-weight-bold">Add Condition </span>
                    <i className="far fa-plus-square" onClick={() => this.handleNewContainsCondition(item)}></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mb-4" style={{ width: "50%", float: "right" }}>
            <table>
              <tbody>
                <tr>
                  <td colSpan="2">Does Not Contain:</td>
                </tr>
                {notContainsList}
                <tr>
                  <td colSpan="3">
                    <span className="font-weight-bold">Add Condition </span>
                    <i className="far fa-plus-square" onClick={() => this.handleNewNotContainsCondition(item)}></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="clearfix"></div>
        </React.Fragment>
      );
    });

    return (
      <div>
        {itemList}
        <span className="font-weight-bold">Add Bucket </span>
        <i className="far fa-plus-square" onClick={() => this.handleNewBucket()}></i>
      </div>
    );
  }
}
export default CampaignGroupList;
